<script lang="ts">
import { defineComponent } from 'vue-demi'

export default defineComponent({
  props: {
    width: {type: Number, required: true},
    height: {type: Number, required: true},
  },
  data() {
    return {
    }
  },
  methods: {
  },
})
</script>

<template>
  <div
    role="presentation"
    :style="{width: `${width}px`, height: `${height}px`}"
  >
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.46512 17.3723C1.21095 17.1376 1.0062 16.8444 0.872052 16.499C0.737906 16.1535 0.653181 15.7886 0.632001 15.391C0.596699 14.7198 0.702604 14.1137 0.956775 13.5532C1.20389 12.9992 1.57102 12.4909 2.06524 12.0347C2.78539 11.3699 3.72441 10.816 4.8823 10.3858C6.04019 9.95569 7.3181 9.63635 8.70898 9.43431C10.114 9.23228 11.5402 9.12801 13.0016 9.12149C14.4631 9.12801 15.8893 9.23228 17.2802 9.43431C18.664 9.64286 19.9349 9.95569 21.0716 10.3793C22.2153 10.8094 23.1543 11.3634 23.8886 12.0412C24.3687 12.4844 24.7429 12.9862 24.9971 13.5336C25.2583 14.0876 25.3854 14.7002 25.3642 15.3715C25.3572 16.1992 25.0818 16.8574 24.5593 17.3397C24.3617 17.5222 24.1216 17.6655 23.8604 17.7503C23.5921 17.8415 23.3026 17.8741 22.992 17.8219L19.0453 17.2028C18.7417 17.1572 18.4875 17.092 18.2686 17.0073C18.0568 16.9291 17.8732 16.8248 17.7391 16.701C17.5697 16.5446 17.4496 16.3425 17.3861 16.1014C17.3155 15.8668 17.2802 15.5865 17.2802 15.2737L17.259 14.2636C17.259 14.1202 17.2025 14.0029 17.0896 13.8986C17.0331 13.8465 16.9766 13.8074 16.906 13.7683C16.8283 13.7357 16.7648 13.7161 16.7083 13.69C16.3482 13.5923 15.8258 13.5141 15.148 13.4619C14.4631 13.4163 13.75 13.3837 13.0087 13.3772C12.2533 13.3837 11.5402 13.4033 10.8483 13.4554C10.1705 13.5076 9.65506 13.5923 9.28793 13.6966C9.2385 13.7161 9.17496 13.7357 9.10436 13.7617C9.02669 13.7943 8.96315 13.8399 8.89961 13.8986C8.77958 14.0094 8.73016 14.1332 8.73016 14.2766L8.7231 15.2607C8.7231 15.5865 8.6878 15.8668 8.61014 16.0949C8.54659 16.336 8.43363 16.5315 8.25712 16.6945C8.12298 16.8183 7.95353 16.9226 7.73466 17.0073C7.51579 17.092 7.26162 17.1572 6.96509 17.2093L2.96896 17.835C2.65831 17.8871 2.38296 17.8676 2.12879 17.7763C1.88167 17.6786 1.66281 17.5547 1.46512 17.3723Z"
        fill="white"
      />
    </svg>
  </div>
</template>

